import { FaJava } from "react-icons/fa";
import {
  SiAndroid,
  SiCss3,
  SiExpo,
  SiFfmpeg,
  SiGithubpages,
  SiGnubash,
  SiGooglemaps,
  SiGraphql,
  SiHtml5,
  SiJavascript,
  SiJest,
  SiNetlify,
  SiNextdotjs,
  SiPlaywright,
  SiPostgresql,
  SiPrisma,
  SiRclone,
  SiReact,
  SiReacthookform,
  SiReactquery,
  SiRedis,
  SiRedux,
  SiRust,
  SiStorybook,
  SiSupabase,
  SiTailwindcss,
  SiTypescript,
  SiVercel,
  SiZod,
} from "react-icons/si";
import { TbBrandReactNative, TbSailboat } from "react-icons/tb";

// Slug -> icon + label. Projects reference stack entries by slug so the data
// files stay plain objects with no JSX in them. List a project's core
// technologies: languages, frameworks, and the widely used tools the app needs
// to function (database, maps, hosting). Not every package, and not services
// it merely calls.
export const stackIcons = {
  android: { Icon: SiAndroid, label: "Android" },
  bash: { Icon: SiGnubash, label: "Bash" },
  css: { Icon: SiCss3, label: "CSS" },
  expo: { Icon: SiExpo, label: "Expo" },
  ffmpeg: { Icon: SiFfmpeg, label: "FFmpeg" },
  "github-pages": { Icon: SiGithubpages, label: "GitHub Pages" },
  "google-maps": { Icon: SiGooglemaps, label: "Google Maps" },
  graphql: { Icon: SiGraphql, label: "GraphQL" },
  html: { Icon: SiHtml5, label: "HTML" },
  java: { Icon: FaJava, label: "Java" },
  javascript: { Icon: SiJavascript, label: "JavaScript" },
  jest: { Icon: SiJest, label: "Jest" },
  netlify: { Icon: SiNetlify, label: "Netlify" },
  nextjs: { Icon: SiNextdotjs, label: "Next.js" },
  playwright: { Icon: SiPlaywright, label: "Playwright" },
  postgis: { Icon: SiPostgresql, label: "Postgres + PostGIS" },
  postgres: { Icon: SiPostgresql, label: "Postgres" },
  prisma: { Icon: SiPrisma, label: "Prisma" },
  rclone: { Icon: SiRclone, label: "rclone" },
  react: { Icon: SiReact, label: "React" },
  "react-hook-form": { Icon: SiReacthookform, label: "React Hook Form" },
  "react-native": { Icon: TbBrandReactNative, label: "React Native" },
  "react-query": { Icon: SiReactquery, label: "TanStack Query" },
  redis: { Icon: SiRedis, label: "Redis" },
  redux: { Icon: SiRedux, label: "Redux Toolkit" },
  rust: { Icon: SiRust, label: "Rust" },
  storybook: { Icon: SiStorybook, label: "Storybook" },
  supabase: { Icon: SiSupabase, label: "Supabase" },
  tailwind: { Icon: SiTailwindcss, label: "Tailwind CSS" },
  typescript: { Icon: SiTypescript, label: "TypeScript" },
  vercel: { Icon: SiVercel, label: "Vercel" },
  // No brand icon exists for Voyage AI in react-icons; the sailboat stands in.
  voyage: { Icon: TbSailboat, label: "Voyage AI" },
  zod: { Icon: SiZod, label: "Zod" },
};
